module.exports = __webpack_public_path__ + "static/img/Bailey-Mckenzie.79531bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bailey-Mckenzie.jpg
// module id = cKwe
// module chunks = 0